import { defineStore } from 'pinia';

import type { SupportedLocale } from '@/plugins/i18n';

export const useLanguageStore = defineStore('language', {
  state: () => ({
    locale: localStorage.getItem('Lang') || 'de',
  }),
  actions: {
    setLanguage(lang: SupportedLocale) {
      this.locale = lang;
      localStorage.setItem('Lang', lang);
    },
  },
  persist: true,
});
